import api from "lib/api/api";

export const fetchAllUsersWithRoles = () => async (dispatch) => {
    try {
        dispatch({ type: 'FETCH_ALL_USERS_REQUEST' });
        const response = await api.get('/admin/users-with-roles');
        dispatch({
            type: 'FETCH_ALL_USERS_SUCCESS',
            payload: response.data
        });
    } catch (error) {
        dispatch({
            type: 'FETCH_ALL_USERS_FAILURE',
            payload: error.response?.data || 'Failed to fetch users'
        });
    }
};

export const syncUserRoles = (userId, roleNames) => async (dispatch) => {
    try {
        dispatch({ type: 'SYNC_USER_ROLES_REQUEST' });
        await api.post(`/admin/users/${userId}/sync-roles`, roleNames);
        dispatch({
            type: 'SYNC_USER_ROLES_SUCCESS'
        });
        dispatch(fetchAllUsersWithRoles()); // Refresh list
    } catch (error) {
        dispatch({
            type: 'SYNC_USER_ROLES_FAILURE',
            payload: error.response?.data || 'Failed to sync roles'
        });
        throw error;
    }
};
